<script>
import { mapGetters } from 'vuex';
import PredictorSlider from './PredictorSlider';
import TopThreeSelection from './TopThreeSelection';
import Presets from './Presets.vue';
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator.vue';
import SavePresetButton from './SavePresetButton.vue';
import ResetButton from './ResetButton.vue';
import SliderPlaceholder from './SliderPlaceholder';

export default {
  name: 'PredictorSliderWrap',
  components: {
    PredictorSlider,
    TopThreeSelection,
    LoadingIndicator,
    Presets,
    SavePresetButton,
    ResetButton,
    SliderPlaceholder,
  },
  props: {
    selections: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    resetPredictor: {
      type: Function,
      required: true,
    },
    env: {
      type: String,
      default: () => 'prod',
      validator: value => {
        return ['prod', 'dev', 'staging'].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    ...mapGetters({
      sliders: 'Predictor/getSliders',
      isLoading: 'Predictor/getLoadingStatus',
      isLoggedIn: 'Predictor/getLogInStatus',
      presetData: 'Predictor/getPresetData',
    }),
  },
  methods: {
    handleCloseSliders() {
      this.$emit('onCloseSliders');
    },
    handleApplySeeting() {
      this.$emit('onApplySetting');
    },
    handleReset() {
      this.resetPredictor();
    },
  },
};
</script>

<template>
  <div class="predictor-slider-wrap">
    <div class="predictor-slider__primary">
      <div class="predictor-slider-setting__header">
        <a
          v-if="isMobile"
          href="javascript:void(0)"
          class="predictor-slider-setting__close-btn"
          @click.prevent="handleCloseSliders"
        ></a>
        <div class="predictor-slider-setting__header-text">Settings</div>
        <ResetButton :reset-predictor="resetPredictor" />
        <SavePresetButton />

        <div class="predictor-slider-setting__header-main">
          <div class="top-three-selections">
            <template v-if="Array.isArray(selections)">
              <TopThreeSelection
                v-for="(selection, index) in selections.slice(0, 3)"
                :ranking="(index + 1) | numberOrdinal"
                :selection-name="selection.name"
                :silk-icon-url="selection.silkImageUrl"
                :competitor-number="selection.competitorNumber"
                :key="`top-three-selection-${index}`"
              />
            </template>
          </div>
        </div>
      </div>
      <Presets v-if="isLoggedIn" :env="env" />
    </div>
    <div
      :class="{ 'predictor-slider-column-wrap--not-presets': presetData.length === 0 }"
      class="predictor-slider-column-wrap"
    >
      <div class="predictor-slider-column">
        <div class="predictor-slider-column-header">
          <p class="predictor-slider-column-header__text">Predictor Settings</p>
          <button class="predictor-slider-setting-header__reset" @click.prevent="handleReset">
            reset
            <LoadingIndicator v-if="isLoading" />
          </button>
        </div>

        <template v-if="isLoading && sliders.length === 0">
          <SliderPlaceholder v-for="(item, index) in Array(8)" :key="`SliderPlaceholder-${index}`" />
        </template>
        <PredictorSlider
          v-for="(slider, index) in sliders"
          :slider-icon="slider.iconUrl"
          :slider-value="slider.defaultValue"
          :slider-label="slider.label"
          :slider-key="slider.sliderKey"
          :key="`predictor-slider-column-left-${index}`"
        />
      </div>
    </div>
    <div v-if="!isMobile" class="predictor-slider__footer">
      <SavePresetButton />
    </div>
    <div v-if="isMobile" class="predictor-slider__apply-setting">
      <div class="apply-setting-btn" @click.prevent="handleApplySeeting">apply settings</div>
    </div>
  </div>
</template>
